import React from 'react'

const FAQsQuestion = () => {

      const faqs = document.querySelectorAll(".faq");

    faqs.forEach(faq => {
      faq.addEventListener("click", () => {
        faq.classList.toggle("active");
      });
    });


  return (
    <>
    
<div className="faqs-section">
    <div className="page-wrapper padding-container">
        <div className="faqs">
        <h1 data-aos="fade-up" data-aos-duration="1000">We’ve <span>answered</span> all Your <span>Questions</span></h1>
          <div className="faq" data-aos="fade-up" data-aos-duration="1000">
    <div className="faq-top"><h3>What is the timing of your office operations?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    <div className="faq-content">
      <p>We are open from Monday to Friday. 09:00 a.m. to 06:00 p.m. with one hour Lunch and Prayer break from 01:15 p.m. to 02:15 p.m. <br/>
Friday Break from 01:00 p.m. to 02:30 p.m. <br/>
Saturdays and Sunday we are Off.<br/>
We'll be able to receive your phone calls during Office Hours.<br/>
We will not be able to receive your phone calls on Public Holidays, Saturdays and Sundays and other than office working hours.</p>
    </div>
  </div>

  <div className="faq" data-aos="fade-up" data-aos-duration="1000">
    <div className="faq-top">    <h3>Where we are located?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>

    <div className="faq-content">
      <p>We are based in Shadman Colony, in the city of Gujrat, Pakistan.</p>
    </div>
  </div>

  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

<div className="faq-top">     <h3>Why does your WhatsApp number use an automated response system?</h3>

    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>

    <div className="faq-content">
      <p>Due to a high volume of inquiries — many of which are received outside our regular business hours — we have implemented this automated system to assist you 24/7. <br/>
As stated earlier, our official working hours are Monday to Friday, from 9:00 a.m. to 6:00 p.m. However, we have noticed that a significant number of candidates attempt to contact us late at night, on weekends (Saturdays and Sundays), and even during public holidays. <br/>
Please note that using our automated WhatsApp system is the first step in our selection process. Detailed instructions are provided on how to retrieve relevant information by replying with specific digits, one at a time. Unfortunately, many users do not follow these instructions carefully. <br/>
Your ability to follow these simple steps gives us an early indication of how well you can adhere to instructions—an important factor in our selection criteria. Failure to use the automated system correctly may reflect negatively on your application.</p>
    </div>
  </div>

  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top">    <h3>Do you offer services to local customers?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    
    <div className="faq-content">
      <p>No, we are not serving in Local market. That is why no need to call us please.</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top">     <h3>For which fields or disciplines are you accepting CVs from candidates??</h3>

    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    <div className="faq-content">
      <p>If you are beginner, intermediate, expert in Web Designing, Web Development (Frontend/Backend), Graphic Designing, UI/UX Designing, Animation then you can apply in our Software House.</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top"><h3>How can I apply for Permanent Job?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    
    <div className="faq-content">
      <p>We are always looking for Experts or Beginners in different fields. <br/>
If you are in Frontend Development, Backend Development, Fullstack Development, UI/UX, Animations, Graphic or Web Designing, then you can Drop your CVs at: <br/>
<a href="#">jobs@visionbird.com.</a> <br/>
(in the subject line must mention Permanent Job or Internship) <br/>
After applying, please give us one to two working days to reply to you. Normally we reply to you through email, but in some cases we may call you or reply to you through this WhatsApp Number.</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top"><h3>How many types of Internship we are offering?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    
    <div className="faq-content">
      <p>Right now we are offering Three months Unpaid Internship through our Software House. Another one offered by Pakistan Software Export Board and it is of 6 months Paid Internship. Right now Paid Internship through Pakistan Software Houses for IT and ITeS is paused by the Government.</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top"><h3>How to apply for 3 Months Unpaid Internship?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    
    <div className="faq-content">
      <p>For 3 months UnPaid Internship, you should have basic knowledge of the field in which you are applying for. <br/>
If you have Zero Knowledge then you should join any Institute to learn the Basics of your desire field. <br/>
Drop your CV at: <br/>
<a href="#">jobs@visionbird.com </a>
<br/>
(in the subject line must mention Internship) <br/>
After applying, please wait for 1 to 2 working days. One of our HR Managers will reply to you through email or this WhatsApp Number, with Interview/Test date and time. <br/>
Appear on the said date and time, after evaluation you'll be informed through email or phone call about Internship Joining Date (Replying only to those who have been selected for Internship).</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">


    <div className="faq-top"> <h3>How to apply for 6 months Paid Internship offered by Pakistan Software Export Board (PSEB)?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
   
    <div className="faq-content">
      <p>This program is a joint initiative by PSEB (Pakistan Software Export Board) and Riphah International University. It is designed for IT professionals currently employed in the public or private sector across Pakistan. To be eligible, applicants must possess a valid CNIC and have completed 16 years of education (i.e., a bachelor's degree). <br/>
The internship spans six months and offers a monthly stipend of PKR 30,000. To apply, please register by visiting the following link: <br/>
:point_right: https://skills.techdestination.com/jobs <br/>
Once on the website, select "INTERNSHIP" from the main page to begin the application process.</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top"> <h3>How long will it take to receive a response to my application?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    
    <div className="faq-content">
      <p>When you submit your CV via email or WhatsApp, it will be reviewed by the relevant department. If your profile meets the initial criteria, you will be contacted for a test or interview through the WhatsApp number or email address provided in your CV. Please ensure you monitor both platforms, as most responses are sent within 24 hours or one working day. <br/>
If you are invited for a test or interview, it is essential to arrive on the exact date and time provided. Punctuality is strictly enforced due to a limited number of available slots. Late arrivals exceeding 10 minutes will not be permitted to participate, as our security team has been instructed accordingly. We appreciate your understanding—your time, and ours, is valuable.</p>
    </div>
  </div>


  <div className="faq" data-aos="fade-up" data-aos-duration="1000">

    <div className="faq-top"> <h3>What are the steps involved in the application process?</h3>
    <i id="plus" className="fa-solid fa-plus"></i>
    <i id="minus" className="fa-solid fa-minus"></i>
    </div>
    
    <div className="faq-content">
      <p>Initial Screening <br/>
Receiving information through our automated WhatsApp number is the first step in the shortlisting process. Please follow the instructions carefully to proceed. <br/>
Interview and Practical Test <br/>
Once you submit your CV, you may be shortlisted and invited for an interview and practical test. Please bring your laptop, as both the verbal interview and hands-on assessment will take place on the same day. <br/>
Post-Interview Process <br/>
If you successfully complete the interview and practical test (usually evaluated within one to two working days), and you meet our selection criteria, you may be offered a permanent position or internship, depending on what you applied for. <br/>
Please note: If no immediate permanent vacancies are available, your application will be kept in our pipeline. We will contact you when a suitable opportunity matching your experience becomes available. <br/>
No Response Follow-up <br/>
If you do not receive a response within three to four working days, it may indicate that your interview or test did not meet our requirements. However, you are welcome to reapply, as there are no restrictions on submitting a new application.</p>
    </div>
  </div>


</div>
    </div>
</div>
    </>
  )
}

export default FAQsQuestion
